import { format } from 'date-fns-tz';

import { type TemplateOption } from '../../../../../controllers/edit/types';

import { TimingStatus } from './types';

const formatDateForProp = (epoch: number) => format(new Date(epoch), 'yyyy-MM-dd');

const getTimingStatus = (template?: TemplateOption | null) => {
	if (template && template.restrictions.length) {
		return TimingStatus.Template;
	}

	if (template && template.restrictions) {
		return TimingStatus.NoRestriction;
	}

	return TimingStatus.Custom;
};

export { formatDateForProp, getTimingStatus };
